/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorsectiontitleplaceholder4Inputs */

const en_menueditorsectiontitleplaceholder4 = /** @type {(inputs: Menueditorsectiontitleplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Starters`)
};

const de_menueditorsectiontitleplaceholder4 = /** @type {(inputs: Menueditorsectiontitleplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Vorspeisen`)
};

/**
* | output |
* | --- |
* | "e.g. Starters" |
*
* @param {Menueditorsectiontitleplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorsectiontitleplaceholder4 = /** @type {((inputs?: Menueditorsectiontitleplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorsectiontitleplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorsectiontitleplaceholder4(inputs)
	return de_menueditorsectiontitleplaceholder4(inputs)
});
export { menueditorsectiontitleplaceholder4 as "menuEditorSectionTitlePlaceholder" }